var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-table",
    { staticClass: "custom-table" },
    [
      _c("CustomTableHeader", { attrs: { columns: _vm.columns } }),
      _vm._v(" "),
      _c(
        "CustomTableBody",
        _vm._g(
          {
            attrs: {
              "table-type": _vm.tableType,
              records: _vm.records,
              actions: _vm.actions,
            },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }